<template>
  <div>
    <div
      v-for="message in messages"
      :key="message.id"
    >
      <SnackBarItem :message="message" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SnackBarItem from '@/components/ui/SnackBar/SnackBarItem.vue'

  export default {
    components: {
      SnackBarItem,
    },
    computed: {
      ...mapGetters('snackbar', ['messages',]),
    },
  }
</script>
